// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.shared.device.MasterBaudRateResponse */
/* istanbul ignore next */
@GandalfModel
export class MasterBaudRateResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	masterBaudRateId!: number;

	@GandalfProperty({ designType: Number })
	value!: number;

}
